/* Jannaty — Product Image Card Style + Color Slideshow */
(function () {

  /* ── Card Style ─────────────────────────────────────────── */
  function applyCardStyle() {
    document.querySelectorAll('.product-media-container').forEach(function (el) {
      el.style.setProperty('overflow', 'visible', 'important');
    });
    document.querySelectorAll('div.product-media').forEach(function (el) {
      el.style.setProperty('border-radius', '16px', 'important');
      el.style.setProperty('overflow', 'hidden', 'important');
      if (window.innerWidth >= 750) {
        el.style.setProperty('box-shadow', '0 6px 28px rgba(0,0,0,0.14)', 'important');
      }
    });
    var gallery = document.querySelector('media-gallery');
    if (gallery && window.innerWidth <= 749) {
      gallery.style.setProperty('padding-left', '16px', 'important');
      gallery.style.setProperty('padding-right', '16px', 'important');
      gallery.style.setProperty('overflow', 'visible', 'important');
      gallery.style.setProperty('display', 'block', 'important');
      gallery.style.setProperty('box-sizing', 'border-box', 'important');
    }
  }

  /* ── Helpers ─────────────────────────────────────────────── */
  function getColorInputs() {
    var fieldset = document.querySelector('fieldset.variant-option');
    if (fieldset) return Array.from(fieldset.querySelectorAll('input[type="radio"]'));
    return Array.from(document.querySelectorAll('.variant-option input[type="radio"], input[name*="Farbe"]'));
  }

  function getCurrentIndex(inputs) {
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].checked) return i;
    }
    return 0;
  }

  function goTo(idx) {
    var inputs = getColorInputs();
    if (!inputs.length) return;
    if (idx < 0) idx = inputs.length - 1;
    if (idx >= inputs.length) idx = 0;
    var input = inputs[idx];
    var label = document.querySelector('label[for="' + input.id + '"]');
    if (label) { label.click(); } else {
      input.checked = true;
      input.dispatchEvent(new Event('input',  { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  /* ── Fixed Arrows ────────────────────────────────────────── */
  function initArrows() {
    if (document.getElementById('jn-prev')) return;

    function makeBtn(id, dir) {
      var btn = document.createElement('button');
      btn.id = id;
      btn.setAttribute('type', 'button');
      btn.setAttribute('aria-label', dir === 'prev' ? 'Vorherige Farbe' : 'Nächste Farbe');
      btn.innerHTML = dir === 'prev'
        ? '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>'
        : '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>';
      btn.style.cssText = [
        'position:fixed','z-index:2147483600','display:none',
        'width:40px','height:40px','background:rgba(255,255,255,0.92)',
        'border:none','border-radius:50%','cursor:pointer',
        'align-items:center','justify-content:center',
        'box-shadow:0 2px 10px rgba(0,0,0,0.2)',
        'transition:background 0.15s','outline:none','padding:0',
        'transform:translateY(-50%)',
      ].join(';');
      btn.addEventListener('mouseenter', function () { this.style.background = '#fff'; });
      btn.addEventListener('mouseleave', function () { this.style.background = 'rgba(255,255,255,0.92)'; });
      btn.addEventListener('click', function (e) {
        e.stopPropagation(); e.preventDefault();
        goTo(getCurrentIndex(getColorInputs()) + (dir === 'prev' ? -1 : 1));
      });
      document.body.appendChild(btn);
      return btn;
    }

    var prev = makeBtn('jn-prev', 'prev');
    var next = makeBtn('jn-next', 'next');

    function position() {
      var gallery = document.querySelector('media-gallery');
      if (!gallery) { prev.style.display = 'none'; next.style.display = 'none'; return; }
      var rect = gallery.getBoundingClientRect();
      if (rect.width < 10 || rect.height < 10) { prev.style.display = 'none'; next.style.display = 'none'; return; }
      var midY = rect.top + rect.height * 0.5;
      var inset = window.innerWidth <= 749 ? rect.left + 28 : rect.left + 16;
      prev.style.display = 'flex'; prev.style.left = inset + 'px'; prev.style.top = midY + 'px';
      next.style.display = 'flex'; next.style.left = (rect.right - (window.innerWidth <= 749 ? 68 : 56)) + 'px'; next.style.top = midY + 'px';
    }

    window.addEventListener('scroll', position, { passive: true });
    window.addEventListener('resize', position, { passive: true });
    setInterval(position, 200);
    position();
  }

  /* ── Init ────────────────────────────────────────────────── */
  function init() {
    applyCardStyle();
    initArrows();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  setTimeout(init, 800);

})();
